<template>
    <div>
        <search-box :columns="comSearchBoxColumns" @search="search" @btnReset="handleReset">
            <el-form-item label="账单周期">
                <el-date-picker
                    type="monthrange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    v-model="formData.date"
                    style="width: 100%;"></el-date-picker>
            </el-form-item>
        </search-box>

    <QS-common-table
      :data="tableData"
      :columns="comTableColumns"
      row-key="id"
      :pagination="paginationData"
      @change="paginationChange"
    />
    </div>
</template>

<script>
// eslint-disable-next-line import/no-cycle
import config from './config'
import { reconciliationSummaryListApi } from './services'
import moment from 'moment'

export default {
  name: 'payAccountConf',
  data() {
    const { comSearchBoxColumns, comTableColumns } = config.call(this)
    return {
      formData: {
        date: [],
      },
      params: {},
      comSearchBoxColumns,
      comTableColumns,
      tableData: [],
      paginationData: {
        pageSize: 10,
        pageNum: 1,
        total: 0,
        pageSizes: [5, 10, 20, 50],
      },
    }
  },
  watch: {
    'formData.date': {
      handler(o) {
        if (Array.isArray(o) && o.length === 2) {
          this.formData.billCycleStart = moment(o[0]).format('YYYYMM')
          this.formData.billCycleEnd = moment(o[1]).format('YYYYMM')
        }
      },
      deep: true,
    },
  },
  methods: {
    search(formData) {
      this.paginationData.pageSize = 10
      this.paginationData.pageNum = 1

      this.params = { ...formData,
        billCycleEnd: this.formData.billCycleEnd,
        billCycleStart: this.formData.billCycleStart }
      this.reconciliationSummaryList()
    },
    handleReset() {
      this.paginationData.pageSize = 10
      this.paginationData.pageNum = 1
      this.params = {}
      this.formData = {
        date: [],
      }
      this.reconciliationSummaryList()
    },
    paginationChange(payload) {
      const {
        pagination: { pageSize, pageNum },
      } = payload
      this.paginationData.pageSize = pageSize
      this.paginationData.pageNum = pageNum
      this.reconciliationSummaryList()
    },
    // eslint-disable-next-line vue/no-unused-properties
    openBillDetail(row) {
      this.$router.push({
        path: '/finance/order_detail',
        query: {
          billId: row.billId,
          billCycle: row.billCycle,
        },
      })
    },
    async reconciliationSummaryList() {
      const [err, _data] = await this.$to(reconciliationSummaryListApi({
        ...this.params,
        pageNum: this.paginationData.pageNum,
        pageSize: this.paginationData.pageSize,
      }))

      if (err) return
      const { code } = _data
      let { data } = _data
      if (code === 1) {
        if (!data) {
          data = {}
        }
        if (!data.items) {
          data.items = []
        }
        this.paginationData.total = data.totalNum
        this.tableData = data.items
      }
    },
  },
  created() {
    this.reconciliationSummaryList()
  },

}
</script>

<style lang="scss" scoped></style>
